var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-container"},[_c('GiftCardReminder'),_vm._v(" "),_c('Social'),_vm._v(" "),_c('Links')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }